module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-R-IGZO-2.f9e12f27.jpeg";